import { useTranslation } from 'react-i18next';

import { CurrencyType } from '../../../constants/currencies';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './TranslateAnswerPopup.module.css';
import { SvgIcon } from '../../Molecules';
import { SVGIconType } from '../../../constants/svgIcon';

type TranslateAnswerPopupProps = {
  language: string;
  currencyType: CurrencyType;
  fee: number;
  onPrimary: () => void;
  onCancel: () => void;
};

export const TranslateAnswerPopup = (props: TranslateAnswerPopupProps) => {
  const { language, currencyType, fee, onPrimary, onCancel } = props;
  const { t } = useTranslation();

  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPrimary}
      onSecondaryButtonClick={onCancel}
      secondaryButtonLabel={t('No')}
      primaryButtonLabel={''}
      primaryButtonFee={{ type: currencyType, amount: fee }}
    >
      <div className={styles.translate}>
        <SvgIcon
          name={SVGIconType.Translation}
          className={styles.titleIcon}
          stroke={'#000000'}
          fill={'#000000'}
          color={'#000000'}
        />
        <p className={styles.textTitle}>{`${t(
          'Auto-translation: ',
        )}${language}`}</p>
        <p className={styles.textRed}>{t('Existing text will be cleared.')}</p>
        <p className={styles.textNormal}>
          {t(
            'Are you sure you want to use auto-translation to translate the answer?',
          )}
        </p>
      </div>
    </BasicPopupContainer>
  );
};
